import NAV_CATALOG from '../config/catalog';
import { HeaderNavContext, NavItemId, NavSurface, ResolvedNavItem } from '../interfaces';

import isNavItemActive from './isNavItemActive';
import resolveValue from './resolveValue';

const shouldShowItem = (id: NavItemId, ctx: HeaderNavContext): boolean => {
    const item = NAV_CATALOG[id];
    return item.visible ? item.visible(ctx) : true;
};

const resolveNode = (
    id: NavItemId,
    ctx: HeaderNavContext,
    surface: NavSurface,
    pathname: string,
): ResolvedNavItem | null => {
    const item = NAV_CATALOG[id];

    if (!shouldShowItem(id, ctx)) return null;

    const children = item.children
        ?.map(childId => resolveNode(childId, ctx, surface, pathname))
        .filter((child): child is ResolvedNavItem => Boolean(child));

    if (item.children && !children?.length) return null;

    const href = resolveValue(item.href, ctx);

    return {
        id: item.id,
        labelKey: item.labelKey,
        href,
        action: item.action,
        children,
        badge: item.badge?.(ctx) ?? null,
        icon: resolveValue(item.icon, ctx),
        testId: item.testIds[surface],
        isActive: isNavItemActive({ id: item.id, href }, pathname),
    };
};

const resolveNav = (
    tree: NavItemId[],
    ctx: HeaderNavContext,
    surface: NavSurface,
    pathname: string,
): ResolvedNavItem[] =>
    tree
        .map(node => resolveNode(node, ctx, surface, pathname))
        .filter((item): item is ResolvedNavItem => Boolean(item));

export default resolveNav;
